enum ProviderAuthStatusEnum{
    Success = 'Success',
    Error = 'Error'
}

export default ProviderAuthStatusEnum;

